import { render, staticRenderFns } from "./col.vue?vue&type=template&id=04b61478"
import script from "./col.vue?vue&type=script&lang=js"
export * from "./col.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/joinmc-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b61478')) {
      api.createRecord('04b61478', component.options)
    } else {
      api.reload('04b61478', component.options)
    }
    module.hot.accept("./col.vue?vue&type=template&id=04b61478", function () {
      api.rerender('04b61478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/McTableComp/col.vue"
export default component.exports